module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "result"
  }, [_c('div', {
    staticClass: "success"
  }, [_c('icon', {
    attrs: {
      "type": "success"
    }
  }), _vm._v(" "), _c('span', [_vm._v("提交成功")])], 1), _vm._v(" "), (!_vm.successFinalPage) ? _c('m-column', {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "10px"
    },
    attrs: {
      "title": "爆款推荐"
    }
  }, [_c('div', {
    staticClass: "recommendation",
    slot: "body"
  }, [_c('swiper', {
    attrs: {
      "auto": "",
      "loop": "",
      "aspect-ratio": 260 / 702,
      "interval": 8000,
      "list": _vm.swiperList,
      "show-desc-mask": false,
      "dots-position": "center"
    },
    model: {
      value: (_vm.index),
      callback: function($$v) {
        _vm.index = $$v
      },
      expression: "index"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "left-nav",
    on: {
      "click": function($event) {
        _vm.index = _vm.index - 1 < 0 ? _vm.swiperList.length - 1 : _vm.index - 1
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    staticClass: "right-nav",
    on: {
      "click": function($event) {
        _vm.index = _vm.index + 1 > _vm.swiperList.length - 1 ? 0 : _vm.index + 1
      }
    }
  }, [_vm._v(">")]), _vm._v(" "), (_vm.index === 0) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("年轻人的第一款国民级年金险"), _c('span', [_vm._v("¥500.00/月起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("无需健康告知")]), _vm._v(" "), _c('span', [_vm._v("满5年后开始领取")]), _vm._v(" "), _c('span', [_vm._v("领取直至终身")]), _vm._v(" "), _c('span', [_vm._v("身故至少返还保费")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 1) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("孝亲宝老年恶性肿瘤疾病保险"), _c('span', [_vm._v("¥461.00/年起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("癌症全面保障")]), _vm._v(" "), _c('span', [_vm._v("45-75岁均可保")]), _vm._v(" "), _c('span', [_vm._v("无需体检")]), _vm._v(" "), _c('span', [_vm._v("三高可投保")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 2) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("【轻症豁免版】至尊保重疾险"), _c('span', [_vm._v("¥180.00/年起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("保障病种高达130种")]), _vm._v(" "), _c('span', [_vm._v("轻症确诊后额外赔付")]), _vm._v(" "), _c('span', [_vm._v("不影响重疾保障")]), _vm._v(" "), _c('span', [_vm._v("且豁免后期所有保费")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 3) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("【升级轻症版】至尊保重大疾病保险"), _c('span', [_vm._v("¥414.00/年起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("保障覆盖131种常见疾病（81种重疾+50种轻症）")]), _vm._v(" "), _c('span', [_vm._v("价格超低")]), _vm._v(" "), _c('span', [_vm._v("确诊即赔")]), _vm._v(" "), _c('span', [_vm._v("保障终身")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 4) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("优护宝定期意外险"), _c('span', [_vm._v("¥249.00/年起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("价格行业最低")]), _vm._v(" "), _c('span', [_vm._v("免检保额最高")]), _vm._v(" "), _c('span', [_vm._v("按需灵活投保")]), _vm._v(" "), _c('span', [_vm._v("责任涵盖伤残")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 5) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("百医百顺百万医疗险"), _c('span', [_vm._v("¥117.00起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("百万保额")]), _vm._v(" "), _c('span', [_vm._v("百元价格")]), _vm._v(" "), _c('span', [_vm._v("投保三年")]), _vm._v(" "), _c('span', [_vm._v("可续保到百岁")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 6) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("优爱宝终身寿险"), _c('span', [_vm._v("¥270.00/年起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("首创交至百岁")]), _vm._v(" "), _c('span', [_vm._v("免检保额最高")]), _vm._v(" "), _c('span', [_vm._v("价格行业最低")]), _vm._v(" "), _c('span', [_vm._v("责任涵盖全残")])])]) : _vm._e(), _vm._v(" "), (_vm.index === 7) ? _c('div', [_c('p', {
    staticClass: "name"
  }, [_vm._v("优护宝终身意外险"), _c('span', [_vm._v("¥240.00/年起")])]), _vm._v(" "), _c('p', {
    staticClass: "slogan"
  }, [_c('span', [_vm._v("首创终身意外险")]), _vm._v(" "), _c('span', [_vm._v("老有所保")]), _vm._v(" "), _c('span', [_vm._v("涵盖意外身故")]), _vm._v(" "), _c('span', [_vm._v("全残和伤残")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (!_vm.successFinalPage) ? _c('div', {
    staticClass: "wkb"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_c('p', [_vm._v("温馨提示：")]), _vm._v(" "), _c('p', [_vm._v("1、" + _vm._s(_vm.tip))]), _vm._v(" "), _vm._m(1)])]) : _vm._e(), _vm._v(" "), (!_vm.successFinalPage) ? _c('div', {
    staticClass: "btns"
  }, [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.goEvaluation($event)
      }
    }
  }, [_vm._v("我要评价")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Product',
        params: {
          productId: this.$store.state.order.productId,
          userId: this.$store.state.order.userId
        },
        query: this.$route.query.activityCode ? '' : this.$route.query
      }
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("再次购买")])], 1), _vm._v(" "), _vm._m(2)], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wkb-wx"
  }, [_c('img', {
    attrs: {
      "src": "static/images/wkb_wx.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("更多爆款产品，请关注悟空保微信号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("2、关注悟空保微信号"), _c('a', [_vm._v("iwukongbao")]), _vm._v("，点击底部“我的”菜单>个人中心，用投保手机号登录查看投保详情。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("悟空保客服热线："), _c('a', {
    attrs: {
      "id": "tel-ask-about",
      "href": "tel:400-661-2992"
    }
  }, [_vm._v("400-661-2992")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-186b46fc"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Result.vue
// module id = 632
// module chunks = 1